import { Trans as _Trans } from "@lingui/react";
import { useCallback, useEffect, useState } from 'react';
import { useGetAveragePriceCounter } from './useGetAveragePriceCounter';
import { useAppConfiguration, useInterval } from '@wkda/funnel-components';
import { getLocaleForNumberFormatting } from '@wkda/funnel-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function PricedCarsCounter(_ref) {
  let {
    element = 'h1',
    ...formattedPricepParams
  } = _ref;
  const {
    formatted: pricedCarCount
  } = usePricedCarsCounter(formattedPricepParams);
  const E = element;
  return /*#__PURE__*/_jsx(E, {
    className: "priced-cars-title",
    children: /*#__PURE__*/_jsx(_Trans, {
      id: "carleadCreation.form.pricedCarCount.title",
      message: "Bewerte dein Auto in <0>weniger als einer Minute</0>, wie es heute <1/><2><3>{pricedCarCount}</3> Kunden</2> getan haben",
      values: {
        pricedCarCount: pricedCarCount
      },
      components: {
        0: /*#__PURE__*/_jsx("strong", {}),
        1: /*#__PURE__*/_jsx("br", {}),
        2: /*#__PURE__*/_jsx("strong", {}),
        3: /*#__PURE__*/_jsx("span", {
          className: "priced-cars-title-counter"
        })
      }
    })
  });
}
export function usePricedCarsCounter(params) {
  const hardcodedInitialCount = 1024;
  const baseIntervalRateInMilis = 1 /* second */ * 1000; /* in miliseconds */
  const baseLeadsIntervalInSecs = 1 /* hour */ * 60 /*in minutes */ * 60; /* in seconds */

  const {
    data: averagePriceCounter,
    status
  } = useGetAveragePriceCounter(params?.updateInterval);
  const {
    fullLocale
  } = useAppConfiguration();
  const hasCount = averagePriceCounter?.currentLeads !== undefined;
  const currentCarleads = averagePriceCounter?.currentLeads ?? hardcodedInitialCount;
  const leadsPerHour = averagePriceCounter?.leadsPerHour ?? 0;
  const [currentCounter, setCounter] = useState(currentCarleads ?? 0);

  /**
   * effect used to only update the counter with the latest carleads from backend
   * **/
  useEffect(() => {
    if (hasCount) {
      setCounter(currentCarleads);
    }
  }, [currentCarleads, hasCount]);
  const intervalDelay = leadsPerHour > 0 ? baseIntervalRateInMilis / (leadsPerHour / baseLeadsIntervalInSecs) : baseIntervalRateInMilis;
  const intervalCb = useCallback(() => {
    setCounter(prevTime => {
      return prevTime + 1;
    });
  }, []);
  useInterval(intervalCb, intervalDelay);
  const {
    locale = fullLocale,
    formatOptions = {}
  } = params ?? {};
  return {
    counter: currentCounter,
    formatted: currentCounter.toLocaleString(getLocaleForNumberFormatting(locale), {
      style: 'decimal',
      useGrouping: true,
      ...formatOptions
    }),
    status
  };
}